import { render, staticRenderFns } from "./schools.vue?vue&type=template&id=2013d3ef&scoped=true"
import script from "./schools.vue?vue&type=script&lang=js"
export * from "./schools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2013d3ef",
  null
  
)

export default component.exports